import { render, staticRenderFns } from "./sendnotice.vue?vue&type=template&id=3f102c3b&scoped=true&"
import script from "./sendnotice.vue?vue&type=script&lang=js&"
export * from "./sendnotice.vue?vue&type=script&lang=js&"
import style0 from "./sendnotice.vue?vue&type=style&index=0&id=3f102c3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f102c3b",
  null
  
)

export default component.exports